import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Contact.scss';
import SEO from '../../components/SEO';
const N8N_WEBHOOK = 'https://n8n.kanemx.com/webhook/contact-kanem';

const Contact = () => {
    const { t } = useTranslation();
    const [form, setForm] = useState({
        nom: '',
        email: '',
        telephone: '',
        service: '',
        message: ''
    });
    const [status, setStatus] = useState(null);
    const [loading, setLoading] = useState(false);

    const services = t('contact.services', { returnObjects: true });

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await fetch(N8N_WEBHOOK, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ ...form, dateSoumission: new Date().toISOString() })
            });
            setStatus('success');
            setForm({ nom: '', email: '', telephone: '', service: '', message: '' });
        } catch (err) {
            setStatus('error');
        }
        setLoading(false);
    };

    return (
        <div className="kanem-contact-page">
            <SEO title="Contact" description="Contactez KANEM pour vos projets d'orientation universitaire, visa, immigration ou services digitaux. Réponse sous 24 heures." url="/contact" />

            <div className="kanem-contact-hero">
                <div className="kanem-grain"></div>
                <div className="kanem-circle c1"></div>
                <div className="kanem-contact-hero-content">
                    <p className="kanem-eyebrow">Contact</p>
                    <h1 className="kanem-contact-title">{t('contact.title')}</h1>
                    <p className="kanem-tagline">{t('contact.subtitle')}</p>
                </div>
            </div>

            <div className="kanem-contact-body">
                <div className="kanem-contact-inner">

                    <div className="kanem-contact-info">
                        <div className="kanem-contact-info-item">
                            <span className="kanem-contact-info-icon">📍</span>
                            <div>
                                <h4>{t('contact.location_title')}</h4>
                                <p>{t('contact.location_desc')}</p>
                            </div>
                        </div>
                        <div className="kanem-contact-info-item">
                            <span className="kanem-contact-info-icon">⏱️</span>
                            <div>
                                <h4>{t('contact.response_title')}</h4>
                                <p>{t('contact.response_desc')}</p>
                            </div>
                        </div>
                        <div className="kanem-contact-info-item">
                            <span className="kanem-contact-info-icon">🔒</span>
                            <div>
                                <h4>{t('contact.confidential_title')}</h4>
                                <p>{t('contact.confidential_desc')}</p>
                            </div>
                        </div>
                        <div className="kanem-contact-info-item">
                            <span className="kanem-contact-info-icon">💬</span>
                            <div>
                                <h4>{t('contact.whatsapp')}</h4>
                                <p>{t('contact.whatsapp_desc')}</p>
                            </div>
                        </div>
                    </div>

                    <div className="kanem-contact-form-wrap">
                        {status === 'success' ? (
                            <div className="kanem-contact-success">
                                <span>✓</span>
                                <h3>{t('contact.success_title')}</h3>
                                <p>{t('contact.success_desc')}</p>
                                <button onClick={() => setStatus(null)} className="kanem-cta-btn">
                                    {t('contact.success_btn')}
                                </button>
                            </div>
                        ) : (
                            <form className="kanem-contact-form" onSubmit={handleSubmit}>
                                <div className="kanem-form-row">
                                    <div className="kanem-form-group">
                                        <label>{t('contact.name')}</label>
                                        <input
                                            type="text"
                                            name="nom"
                                            value={form.nom}
                                            onChange={handleChange}
                                            required
                                            placeholder="Teda Barkay"
                                        />
                                    </div>
                                    <div className="kanem-form-group">
                                        <label>{t('contact.email')}</label>
                                        <input
                                            type="email"
                                            name="email"
                                            value={form.email}
                                            onChange={handleChange}
                                            required
                                            placeholder="teda@exemple.com"
                                        />
                                    </div>
                                </div>
                                <div className="kanem-form-row">
                                    <div className="kanem-form-group">
                                        <label>{t('contact.phone')}</label>
                                        <input
                                            type="tel"
                                            name="telephone"
                                            value={form.telephone}
                                            onChange={handleChange}
                                            placeholder="+227 00 00 00 00"
                                        />
                                    </div>
                                    <div className="kanem-form-group">
                                        <label>{t('contact.service')}</label>
                                        <select
                                            name="service"
                                            value={form.service}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="">{t('contact.select')}</option>
                                            {Array.isArray(services) && services.map(s => (
                                                <option key={s} value={s}>{s}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="kanem-form-group">
                                    <label>{t('contact.message')}</label>
                                    <textarea
                                        name="message"
                                        value={form.message}
                                        onChange={handleChange}
                                        rows={5}
                                        placeholder={t('contact.placeholder_message')}
                                    />
                                </div>
                                {status === 'error' && (
                                    <p className="kanem-form-error">{t('contact.error')}</p>
                                )}
                                <button
                                    type="submit"
                                    className="kanem-cta-btn"
                                    disabled={loading}
                                >
                                    {loading ? t('contact.loading') : t('contact.submit')} →
                                </button>
                            </form>
                        )}
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Contact;
